import { render, staticRenderFns } from "./ScoringDialogSecondLevelTabComponent.vue?vue&type=template&id=988216d8&scoped=true"
import script from "./ScoringDialogSecondLevelTabComponent.js?vue&type=script&lang=js&external"
export * from "./ScoringDialogSecondLevelTabComponent.js?vue&type=script&lang=js&external"
import style0 from "./ScoringDialogSecondLevelTabComponent.vue?vue&type=style&index=0&id=988216d8&prod&scoped=true&lang=scss"
import style1 from "./ScoringDialogSecondLevelTabComponent.vue?vue&type=style&index=1&id=988216d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988216d8",
  null
  
)

export default component.exports